import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useGetListBrokers = () =>
  useQuery({
    queryKey: ['brokers'],
    queryFn: listBrokers,
  });

const listBrokers = async () => {
  const { data } = await api.get<BrokerListProps[]>(
    apiConfig.routes.invest.brokers
  );
  return data;
};

type BrokerListProps = {
  id: number;
  uuid: string;
  active: boolean;
  broker_crypto: boolean;
  broker_exchange: boolean;
  broker_order: boolean;
  display_order: number;
  type: string;
  name: string;
  thumb_img: string;
  url_campaign: string;
};
